<template>
  <button
    class="app-btn"
    :class="css"
    :data-icon="(options && options.icon && !loading) ? options.icon : false"
  >
    <loader v-if="loading" size="small" class="app-btn__loader" />
    <span v-else class="app-btn__label">{{ text }}</span>
    <span v-if="(options && options.icon && !loading)" :class="options.icon"></span>
  </button>
</template>

<script>
import Loader from '@/components/UI/Loader.vue';

export default {
  name: 'Button',
  data() {
    return {
      css: null,
    };
  },
  created() {
    if (this.options) {
      this.css = {
        'app-btn--inverted': this.options.inverted,
        'app-btn--inverted-simple': this.options.simple && this.options.inverted,
        'app-btn--simple': this.options.simple && !this.options.inverted,
        'app-btn--icon': this.options.icon && this.text === '',
      };
    }
  },
  components: {
    Loader,
  },
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Object,
      required: false,
      default: () => null,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
